
import React from 'react';

import Tab from './Tabs/Tab';
import MobileCustom from './MobileCustom';
import MobileMonthly from './MobileMonthly';
import MobileQuarterly from './MobileQuarterly';
import Tabs from './Tabs';

export default function TabsMobile() {
	return (
		<Tabs mobile default='quarterly'>
			<Tab key='monthly'>
				<Tab.Heading>
					<h1>Monthly</h1>
					<h2>Best Value</h2>
				</Tab.Heading>
				<Tab.Content mobile>
					<MobileMonthly />
				</Tab.Content>
			</Tab>
			<Tab key='quarterly'>
				<Tab.Heading>
					<h1>Quarterly</h1>
					<h2>Most Popular</h2>
				</Tab.Heading>
				<Tab.Content mobile>
					<MobileQuarterly />
				</Tab.Content>
			</Tab>
			<Tab key='custom'>
				<Tab.Heading>
					<h1>One-time</h1>
					<h2>Packages</h2>
				</Tab.Heading>
				<Tab.Content mobile>
					<MobileCustom />
				</Tab.Content>
			</Tab>
		</Tabs>
	);
}
